/**
 * Viewport classes and layout measures.
 *
 * Layout decisions read a viewport class, never a pixel width.
 * `useViewport()` in `primitives/viewport` resolves the class at runtime.
 */

export type ViewportClass = "compact" | "medium" | "expanded" | "wide";

/** Minimum widths in px. `compact` is everything below `medium`. */
export const breakpoints = {
    medium: 640,
    expanded: 1024,
    wide: 1440,
} as const;

export const mediaQueries = {
    compact: "(max-width: 639px)",
    medium: "(min-width: 640px) and (max-width: 1023px)",
    expanded: "(min-width: 1024px) and (max-width: 1439px)",
    wide: "(min-width: 1440px)",
    coarsePointer: "(pointer: coarse)",
} as const;

/** Fixed measures in px unless the value is a string. */
export const layout = {
    railWidth: 320,
    railWidthNarrow: 272,
    filterRailWidth: 248,
    workspaceMaxWidth: 1440,
    contentMaxWidth: 880,
    proseMaxWidth: "72ch",
    hitArea: 40,
    viewportGutter: 8,
} as const;

export type Breakpoints = typeof breakpoints;
export type LayoutTokens = typeof layout;
